import { openMeldRequestContextSchema } from "../daemon/profile-identity.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/organization-usage.ts
const nonnegativeCountSchema = z$1.number().int().nonnegative();
const positiveLimitSchema = z$1.number().int().positive();
const organizationUsageOverviewResponseSchema = z$1.strictObject({
	centerAgentWakes: z$1.strictObject({
		dailyLimit: positiveLimitSchema,
		resetsAt: z$1.iso.datetime({ offset: true }),
		usedToday: nonnegativeCountSchema
	}),
	routines: z$1.strictObject({
		count: nonnegativeCountSchema,
		limit: positiveLimitSchema
	})
});
const organizationUsageOverviewRpcInputSchema = z$1.strictObject({ context: openMeldRequestContextSchema });
//#endregion
export { organizationUsageOverviewResponseSchema, organizationUsageOverviewRpcInputSchema };

//# sourceMappingURL=organization-usage.js.map